import PolicyMigrator from './PolicyMigrator'

export default PolicyMigrator
